<template>
  <div>
    <ModalOperatorCheckout
      v-if="showCheckoutOperatorModal"
      :show="showCheckoutOperatorModal"
      @confirm="onModalConfirm"
      persistent
    />
  </div>
</template>

<script>
import checkOperatorCheckoutTimeMixin from "@/mixins/checkOperatorCheckoutTime";
import ModalOperatorCheckout from "@/components/ModalOperatorCheckout";

export default {
  mixins: [checkOperatorCheckoutTimeMixin],
  components: { ModalOperatorCheckout }
};
</script>

<style lang="scss" scoped>
</style>